/** Placeholder — replace with the published Help Center article when ready. */
export const SCHEDULED_EMAILS_HELP_URL = 'https://help.fleetwire.io/';
